import dayjs from 'dayjs'

export const PRESET_OPTIONS = [
  { value: 'hoje', text: 'Hoje' },
  { value: 'ontem', text: 'Ontem' },
  { value: '7d', text: 'Últimos 7 dias' },
  { value: '30d', text: 'Últimos 30 dias' },
  { value: 'mes_atual', text: 'Este mês' },
  { value: 'mes_passado', text: 'Mês passado' },
  { value: 'personalizado', text: 'Personalizado' },
]

/**
 * @returns {{ start: string, end: string }} YYYY-MM-DD
 */
export function getDatesForPreset(preset, customStart, customEnd) {
  const fmt = d => dayjs(d).format('YYYY-MM-DD')
  const today = dayjs().startOf('day')

  if (preset === 'personalizado' && customStart && customEnd) {
    return { start: fmt(customStart), end: fmt(customEnd) }
  }

  switch (preset) {
    case 'hoje':
      return { start: fmt(today), end: fmt(today) }
    case 'ontem': {
      const y = today.subtract(1, 'day')
      return { start: fmt(y), end: fmt(y) }
    }
    case '7d':
      return { start: fmt(today.subtract(6, 'day')), end: fmt(today) }
    case '30d':
      return { start: fmt(today.subtract(29, 'day')), end: fmt(today) }
    case 'mes_atual':
      return { start: fmt(today.startOf('month')), end: fmt(today) }
    case 'mes_passado': {
      const start = today.subtract(1, 'month').startOf('month')
      const end = today.subtract(1, 'month').endOf('month')
      return { start: fmt(start), end: fmt(end) }
    }
    default:
      return { start: fmt(today.subtract(29, 'day')), end: fmt(today) }
  }
}

export function previousPeriodRange(startStr, endStr) {
  const start = dayjs(startStr)
  const end = dayjs(endStr)
  const dias = Math.max(1, end.diff(start, 'day') + 1)
  const prevEnd = start.subtract(1, 'day')
  const prevStart = prevEnd.subtract(dias - 1, 'day')
  return {
    start: prevStart.format('YYYY-MM-DD'),
    end: prevEnd.format('YYYY-MM-DD'),
  }
}
